import CrudTable from "@/components/CrudTable";
import { MODULES } from "@/config/modules";
import { useLookups } from "@/hooks/useLookups";
import { Info } from "@phosphor-icons/react";

export default function Marketing() {
  const { lists, nameMap } = useLookups();
  return (
    <div data-testid="marketing-page" className="space-y-4">
      <div className="flex items-start gap-3 rounded-lg border border-gold/30 bg-gold/5 px-4 py-3 text-sm">
        <Info size={18} weight="fill" className="text-gold mt-0.5 shrink-0" />
        <p className="text-navy">
          <span className="font-semibold">Live Meta &amp; Google Ads sync is simulated (demo data).</span>{" "}
          Spend and leads for those channels populate automatically in production; other channels are entered manually. CPL is auto-calculated.
        </p>
      </div>
      <CrudTable resource="marketing" config={MODULES.marketing} lists={lists} nameMap={nameMap} />
    </div>
  );
}
